import React from 'react';
import { lang } from '../config/lang';
import { UserIcon, BuildingOfficeIcon, WrenchScrewdriverIcon, CurrencyEuroIcon } from '@heroicons/react/24/outline';
import QuotesViewer from '../components/QuotesViewer';

const Dashboard = () => {
  const { dashboard } = lang.fr;

  // Mock data for KPIs
  const kpiData = {
    activeProjects: 12,
    completedProjects: 45,
    satisfiedClients: 98,
    revenue: '€1.2M'
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-2xl font-bold text-white">{dashboard.title}</h1>
        <QuotesViewer />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
          <div className="flex items-center space-x-4">
            <div className="p-3 bg-primary/20 rounded-lg">
              <UserIcon className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h3 className="text-gray-300 text-sm">Clients</h3>
              <p className="text-white text-xl font-semibold">150</p>
            </div>
          </div>
        </div>

        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
          <div className="flex items-center space-x-4">
            <div className="p-3 bg-primary/20 rounded-lg">
              <BuildingOfficeIcon className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h3 className="text-gray-300 text-sm">Projets en cours</h3>
              <p className="text-white text-xl font-semibold">12</p>
            </div>
          </div>
        </div>

        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
          <div className="flex items-center space-x-4">
            <div className="p-3 bg-primary/20 rounded-lg">
              <WrenchScrewdriverIcon className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h3 className="text-gray-300 text-sm">Services actifs</h3>
              <p className="text-white text-xl font-semibold">4</p>
            </div>
          </div>
        </div>

        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
          <div className="flex items-center space-x-4">
            <div className="p-3 bg-primary/20 rounded-lg">
              <CurrencyEuroIcon className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h3 className="text-gray-300 text-sm">Chiffre d'affaires</h3>
              <p className="text-white text-xl font-semibold">€45,000</p>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {/* Active Projects KPI */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
          <h3 className="text-lg font-semibold mb-2">{dashboard.kpis.projects}</h3>
          <p className="text-3xl font-bold text-primary">{kpiData.activeProjects}</p>
        </div>

        {/* Completed Projects KPI */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
          <h3 className="text-lg font-semibold mb-2">{dashboard.kpis.completed}</h3>
          <p className="text-3xl font-bold text-success">{kpiData.completedProjects}</p>
        </div>

        {/* Satisfied Clients KPI */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
          <h3 className="text-lg font-semibold mb-2">{dashboard.kpis.clients}</h3>
          <p className="text-3xl font-bold text-accent">{kpiData.satisfiedClients}%</p>
        </div>

        {/* Revenue KPI */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
          <h3 className="text-lg font-semibold mb-2">{dashboard.kpis.revenue}</h3>
          <p className="text-3xl font-bold text-secondary">{kpiData.revenue}</p>
        </div>
      </div>

      {/* Additional dashboard content can be added here */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-8">
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
          <h2 className="text-xl font-semibold mb-4">Projets Récents</h2>
          {/* Add project list or chart here */}
        </div>
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
          <h2 className="text-xl font-semibold mb-4">Performance Mensuelle</h2>
          {/* Add performance metrics or chart here */}
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 
